import { Text } from '@pets-ui/Text/Text'
import * as stylex from '@stylexjs/stylex'
const baseStyle = stylex.create({
  totalAmount: (fontSize: number, fontStyle: 'italic' | 'normal') => ({
    fontSize,
    fontStyle,
  }),
})

interface AmountProps {
  amount: number
  fontSize?: number
  bold?: boolean
  fontStyle?: 'italic' | 'normal'
  className?: string
}

const Amount = ({
  amount,
  fontSize = 14,
  bold = false,
  fontStyle = 'normal',
  className,
}: AmountProps) => {
  const isPositive = amount >= 0
  return (
    // NOTE: 未來設計會重構，所以先暫時使用 style hard code
    <Text
      rootStyle={baseStyle.totalAmount(fontSize,
        fontStyle)}
      bold={bold}
      // NOTE: className 會和 styleX 打架，有傳入在使用
      {...(className && { className })}
    >
      {!isPositive ? '-' : ''}
      {'$'}
      {Math.abs(amount).toLocaleString()}
    </Text>
  )
}

export default Amount
